export default class SocketError extends Error {
  constructor(readonly message: string) {
    super(message);
  }
}
